module.exports = __webpack_public_path__ + "static/media/i.d_logo.921c52c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/i.d_logo.jpg
// module id = 453
// module chunks = 0